import { formatDateHuman, parseDateRaw } from "../date-utils";
export const sectionDtoFields = [{
        /*
          name: "protocol",
          title: "Protocollo",
          render: (record: IButcherSectionDTO) => record.section.protocol
        }, {
        */
        name: "workingDate",
        title: "Data",
        render: (record) => formatDateHuman(parseDateRaw(record.section.workingDate))
    }, {
        name: "dailyNumber",
        title: "Lotto",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => record.section.lotNumber
    }, {
        name: "dailyNumber",
        title: "Num.Prog.",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => record.section.dailyNumber
    }, {
        name: "srcTransportDocumentNumber",
        title: "DDT ingresso",
        render: (record) => record.srcTransportDocumentNumber
    }, {
        name: "srcCustomerName",
        title: "Provenienza",
        render: (record) => record.srcCustomerName
    }, {
        name: "dstCustomerName",
        title: "Destinazione",
        render: (record) => record.dstCustomerName
    }, {
        name: "purposeDescription",
        title: "Scopo",
        render: (record) => record.purposeDescription
        /*
        }, {
          name: "roomTypeDescription",
          title: "Stoccaggio",
          render: (record: IButcherSectionDTO) => record.roomTypeDescription
      }, {
        name: "totQuantity",
        title: "Num.Capi",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record: IButcherSectionDTO) => record.section.totQuantity
        */
        /*
       }, {
         name: "totWeight",
         title: "Kg",
         titleClass: "has-text-centered",
         dataClass: "has-text-centered",
         render: (record: IButcherSectionDTO) => record.section.totWeight
         */
        /*
        }, {
          name: "working",
          title: "Lavorazione",
          titleClass: "has-text-centered",
          dataClass: "has-text-centered",
          render: (record: IButcherSectionDTO) => `<i class="material-icons">${record.section.working === 1 ? "check" : ""}</i>`
        }, {
          name: "completed",
          title: "Completato",
          titleClass: "has-text-centered",
          dataClass: "has-text-centered",
          render: (record: IButcherSectionDTO) => `<i class="material-icons">${record.section.completed === 1 ? "check" : ""}</i>`
          */
        /*
        }, {
          name: "active",
          title: "Attiva",
          titleClass: "has-text-centered",
          dataClass: "has-text-centered",
          render: (record: IButcherSectionDTO) => `<i class="material-icons">${record.section.active === 1 ? "check" : "close"}</i>`
        */
    }];
